import { render, staticRenderFns } from "./tableBase.vue?vue&type=template&id=3107104c"
import script from "./tableBase.vue?vue&type=script&lang=js"
export * from "./tableBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports